function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ((useActualHostSelector ? ":host {" : hostSelector + " {")) + "display: block;--recommendation-band-padding-block: 32px;}.recommendation-card" + shadowSelector + " wds-listing-tile" + shadowSelector + " {display: block;height: 100%;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];